import React from 'react';
import { Heart, Coffee } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--dark-gradient)',
      borderTop: '1px solid var(--border-color)',
      padding: '60px 0 40px',
      marginTop: '80px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Animated background elements */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `
          radial-gradient(circle at 10% 20%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
          radial-gradient(circle at 90% 80%, rgba(255, 107, 107, 0.05) 0%, transparent 50%)
        `,
        animation: 'backgroundShift 25s ease-in-out infinite'
      }} />
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '40px'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            
            <h3 style={{
              fontSize: '2rem',
              fontWeight: '700',
              background: 'var(--primary-gradient)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Den Soniske Spalte
            </h3>
          </div>
          
          <p style={{
            fontSize: '1.1rem',
            color: 'var(--text-secondary)',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            Danmarks førende platform for <strong>koncert anmeldelser</strong> og <strong>musik anmeldelser</strong>. 
            Læs professionelle <strong>musikanmeldelser</strong> og <strong>koncertanmeldelser</strong> 
            af både danske og internationale kunstnere.
          </p>
        </div>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          fontSize: '0.9rem',
          color: 'var(--text-muted)',
          paddingTop: '30px',
          borderTop: '1px solid rgba(51, 51, 51, 0.5)'
        }}>
          <span>Lavet med</span>
          <Heart size={16} color="#ff6b6b" style={{ animation: 'ratingPulse 2s ease-in-out infinite' }} />
          <span>og</span>
          <Coffee size={16} color="#8B4513" />
          <span>af Lasse Schütt Christensen © {new Date().getFullYear()}</span>
        </div>
        
        {/* Musical note decorations - hidden on mobile */}
        <div className="floating-note" style={{
          position: 'absolute',
          top: '20px',
          left: '10%',
          opacity: '0.1',
          fontSize: '2rem',
          animation: 'musicNote 10s ease-in-out infinite'
        }}>
          ♪
        </div>
        <div className="floating-note" style={{
          position: 'absolute',
          bottom: '20px',
          right: '15%',
          opacity: '0.08',
          fontSize: '1.5rem',
          animation: 'musicNote 12s ease-in-out infinite 3s'
        }}>
          ♫
        </div>
      </div>
    </footer>
  );
};

export default Footer;
